export default __webpack_public_path__ + "static/hero-bg-598ac82a1df93e1be7aec70524556e26.svg";